import { render } from "./LogAside.vue?vue&type=template&id=5c8d1496&scoped=true"
import script from "./LogAside.vue?vue&type=script&lang=js"
export * from "./LogAside.vue?vue&type=script&lang=js"

import "./LogAside.vue?vue&type=style&index=0&id=5c8d1496&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c8d1496"]])

export default __exports__